import { Grid } from "@mui/material";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";
import EditButtons from "../../../components/EditButtons";
import { ButtonFooter } from "../../../components";
import SubNavbar from "../../../components/SubNavbar";

export default function FormDisplay({ editState, formikProps, setEditState }) {
  return (
    <Grid container spacing={4} style={{ padding: "20px" }}>
      <Grid size={12}>
        <SubNavbar
          pageName={"Agency Details"}
          buttons={[
            <EditButtons editState={editState} setEditState={setEditState} />,
          ]}
        />
      </Grid>

      <FormOne formikProps={formikProps} editState={editState} />
      <FormTwo formikProps={formikProps} editState={editState} />

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            ID={formikProps.values.brandID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Grid>
  );
}
